import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
const PreventiveMeasures = () => {
    useEffect(() => {
        document.title = 'Preventive Measures -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li>  
                 <li>Preventive Measures</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Preventive Measures </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                       <h6>Preventive Measure Against Dengue/Chikungunya/Infectious Diseas</h6>
                    <p>Dear Parents, <br/>

                    We experience an outbreak of Dengue/Chikungunya/other infectious diseases during monsoons every year. All of us are vulnerable and we would like to keep the children as safe as we can, especially during their time in school.  </p>
                   
                   <p>We have been working round the clock to keep the school premises as free of mosquitoes as possible. Regular fogging of the school building and the garden after all students have left the school premises is taking place. We also have been creating an awareness regarding the cause, symptoms and prevention of these diseases through assembly talks, board displays, power point presentations and class discussions. We would appreciate your cooperation in making this campaign a success so that the good health of our children is taken care of. </p>
                   
                   <p>Advisory for Parents: </p>
                    <p> <b> 1) </b> Please send your ward to school in full sleeves uniform shirt with trousers. No Jeans will be permitted. </p>
                    <p> <b> 2) </b> Their bodies could be protected from mosquito bite by applying insect repellent on the exposed part of the body </p>
                    <p> <b> 3) </b> Wash hands properly with soap and water before consuming food. </p>
                    <p> <b> 4) </b> The expiry date of all packed eatables/drinks should always be checked before eating. </p>
                    <p> <b> 5) </b> Plenty of water and fluids should be consumed before stepping out in the heat. </p>
                    <p> <b> 6) </b> Consumption of water, milkshakes, fruit juices, chaat and food material from roadside vendors should be avoided. </p>
                    <p> <b> 7) </b> Don’t send your ward to school if he/she is sick. </p>
                    <p> <b> 8) </b> Don’t let water collect in any containers which are kept open. Standing water is a perfect breeding ground for mosquitoes. </p>
                    <p> <b> 9) </b> Change water in flower vases once in a day </p>
                    <p>As always, the safety of the children is a priority and I do hope that these measures will help to keep the children relatively safe & healthy. </p>
                    <p>With warm regards, <br/>
                    Lomina Rajiv <br/>
                    Principal </p>

                     <p><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/DENGUE&CHIKUNGUNYA.pdf" target='_blank'><u>CLICK HERE TO VIEW - DO's AND DON'Ts FOR DENGUE AND CHIKUNGUNYA</u></Link></p>
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default PreventiveMeasures